<template>

<div class="">
 
   <div class="float-right">


  <b-button v-b-modal.modal-lg v-b-tooltip.hover title="Filter" @click="$bvModal.show('modal-lg')"> <b-icon icon="filter"></b-icon> Filter</b-button>


</div>


 <b-modal id="modal-lg" size="lg" title="Filter" hide-footer>
   
  <div class="panal2">
    <div>
      
      <div class="panal-header2"> </div>
     <div class="panal-body2" id="Courses">

  <div class="filter">

   <b-form-group label="">
      <b-form-radio-group id="radio-group-2"  name="radio-sub-component"  v-model="FilterCourses">
        <b-form-radio value="All" >All Courses</b-form-radio>

        <b-form-radio value="Selected"  >Selected courses</b-form-radio>

        
      </b-form-radio-group>
    </b-form-group>



  </div>
  <hr/>
  <div>
  <h6> Levels </h6>
<span class="col-md-4">Student level</span>
<b-form-select v-model="LevelNameinsert"  class="col-md-9">

      <b-form-select-option v-for = "Level in LevelName" v-bind:key="Level.serial" :value="Level.serial" >{{ Level.StageName }}</b-form-select-option>
    

</b-form-select>


</div>

<hr/>
  <div>
  <h6>Specialization </h6>
<span class="col-md-2">Student Specialization</span>
 <b-form-select v-model="Specializationinsert" class="mb-3 col-md-8">
      <b-form-select-option  v-for = "spac in Specialization" v-bind:key="spac.SpecializationID" :value="spac.SpecializationID">{{spac.SpecializationNameEN}}</b-form-select-option>
      
    </b-form-select>


</div>

<hr/>
  <div>
  <h6>Courses </h6>
  <b-row>
 <b-col class="col-md-2 mt-1">Course Code</b-col>
  <b-form-input v-model="text1" class="col-md-3" placeholder="Enter course code"></b-form-input>
  <b-col class="col-md-2 mt-1">Course Name</b-col>
  <b-form-input v-model="text2" class="col-md-4" placeholder="Enter course Name"></b-form-input>
  </b-row>
   

</div>

      </div>
     </div>

  

  </div>
<div class="text-center col-md-3 float-right">
<b-button class="mt-3  btn-success" block @click="$bvModal.hide('modal-lg'),filteredCourses2() ">Search</b-button></div>
  </b-modal>

   <br/>
   <div class="clearfix"></div>
   

<div class="row">
  <div class="col-sm-12" v-if="loading">   <div class="text-center" >
                  <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div></div>
  <b-row class="col-sm-12" v-else>
  <b-col sm="12" md="3" class="border-right">
     <b-alert show variant="dark">
     

      <div class="row" >
        <div class="col-md-6 text-center"><h6>Current CGPA<br/><span class="text-success">{{Courses[0].CGPA}}</span></h6></div>
         <div class="col-md-6 text-center"><h6>Current Credit<br/><span class="text-success">{{Courses[0].SelectedCredits}}</span></h6></div>
      </div>

<hr/>
      <div class="row">
         <div class="col-md-12 text-center"><h6>Resulted CGPA<br/><span class="text-success">{{Courses[0].ResultedCGPA}}</span></h6></div>
        <div class="col-md-12 text-center"><h6>Resulted GPA<br/><span class="text-success">{{Courses[0].SelectedGPA}}</span></h6></div>
        
      </div>
      <hr/>
 <div class="row">
        <div class="col-md-12 text-center"><h6>Selected Credits<span class="text-success ml-2">{{Courses[0].SelectedCredits}}</span></h6></div>
        
      </div>
      <hr/>
      <div class="row">
        <div class="col-md-12 text-center"><h6>Total Credits<span class="text-success ml-2">{{Courses[0].TotalCredits}}</span></h6></div>
        
      </div>
     </b-alert>
     

   </b-col>
  <b-col sm="12" md="9" class="row">

    <div class="col-sm-12" v-if="cardLoading">   <div class="text-center" >
                  <b-spinner variant="primary" label="Text Centered"></b-spinner>
                </div></div>


    <b-card-group v-else deck v-for = "item in Courses" v-bind:key="item.serial" class="col-md-6 col-sm-12 mb-3" >
     
      <b-card  :header="item.CourseCode"  :id="item.serial" variant="primary" class="select" border-variant="primary" sm="12"  :class="item.Selected ? 'active2' : ''" >
     <b-card-text>Course Name.:{{item.CourseNameEN}}<br/>CreditHours: {{item.CreditHours}}  </b-card-text>
        <hr/>
      <div>
              <!-- v-bind:disabled="!item.Selected ?  true: false" -->
             <fieldset v-bind:disabled="!item.Selected ?  true: false" :id="'select-'+item.serial">
        Grade  
        <select class="w-50"  @change="onChange(item.serial,$event)">
         
          
          <!-- <option v-else-if="selectedgrades.length !=0" v-for = "Grade in item.Grades" v-bind:key="Grade.GradeSerial" :value="Grade.GradeSerial" :selected="(selectedgrades.length!=0 || selectedgrades != null)? selectedgrades.filter(x=> x.name == item.serial && x.grade == Grade.GradeSerial).length>0 : ''"  >{{Grade.GradeName}}</option> -->
          <option v-for = "Grade in item.Grades" v-bind:key="Grade.GradeSerial" :value="Grade.GradeSerial" :selected="(selectedgrades.length!=0 || selectedgrades != null)? selectedgrades.filter(x=> x.name == item.serial && x.grade == Grade.GradeSerial).length>0 : '0'"  >{{Grade.GradeName}}</option>
          <!-- <option v-else v-for = "Grade in item.Grades" v-bind:key="Grade.GradeSerial" :value="Grade.GradeSerial" >{{Grade.GradeName}}</option> -->
           <!-- <option>B</option> -->
          
          </select>
        
             </fieldset>
          </div>
         
         <div class="text-center"><b-button @click="onClick(item);"  class="subButton" > {{ item.Selected? 'DeSelect' : 'Select' }}</b-button></div>
      
        
      
      </b-card>
 
    </b-card-group>
 



  </b-col>
  </b-row>
    
 





</div>






</div>
</template>
<script>
 import studentData from '../../services/student/studentDataServices';

    export default {
        name: 'SelectSubject',
        data() {
          
      return {
        loading: false,
        cardLoading: false, 
       FilterCourses:'All',
        btnDisable:true,
        selected1: undefined,
        selected22: '',
        IsSelected:false,
        Courses:[],
        SelectCourses:[],
        text1:'',
        text2:'',
       LevelName:'',
       LevelNameinsert:'0',
       Specialization:'',
       Specializationinsert:'0',
        
        deleteClicked: false,
        change: false,
        selected2: null,
        selected: '',
       expanded: true,
      text: "Select",
      CoursesSelect:'',
       selectedgrades: []
        
      } 
      
    },
     beforeMount() {
       
         

     },
     created(){
       this.selectedgrades = JSON.parse( localStorage.getItem('selectedsession')) == null ? [] : JSON.parse( localStorage.getItem('selectedsession'))
       this.loading = true
            //this.currenUser.StudentID
            // this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert, this.LevelNameinsert,this.text1,this.text2,this.IsSelected
           studentData.GetCoursesForSelection(this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert,this.LevelNameinsert,this.text1,this.text2,this.IsSelected).then(Response =>{
              //this.isLoading = false ;
               this.Courses = Response.data
                this.empty =false
               // eslint-disable-next-line no-console
            this.loading = false
                this.Courses =  this.Courses.map(gr=>{
                 return {...gr,Grades :[{GradeSerial : 0 , GradeName : "Choose"},...gr.Grades] }
                 
               })
           }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 

           studentData.GetFacultyLevels(this.currenUser.FacultyID_Enrollment).then(Response =>{
            //   this.isLoading = false ;
               this.LevelName = Response.data
                this.empty =false
             
           }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
                studentData.GetFacultySpecializations(this.currenUser.FacultyID_Enrollment).then(Response =>{
            //   this.isLoading = false ;
               this.Specialization = Response.data
                this.empty =false
              
           }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 


               
       },
   computed:{
           currenUser(){
            return  this.$store.state.auth.user
          },
       

       },
     
 
  methods:{
             filteredCourses2(){

this.IsSelected = false;
  this.loading = true;

          if(this.FilterCourses === "All") { 

         this.IsSelected = false;
          } else 
          {
         this.IsSelected = true;
          }

             studentData.GetCoursesForSelection(this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert, this.LevelNameinsert,this.text1,this.text2,this.IsSelected).then(Response =>{
              this.isLoading = false ;
               this.Courses = Response.data
            this.Courses =  this.Courses.map(gr=>{
                 return {...gr,Grades :[{GradeSerial : 0 , GradeName : "Choose"},...gr.Grades] }
                 
               })
                this.empty =false
                this.loading = false;
             
                this.levels = this.AcademicPlan.map(item=> item.LevelName)
                this.levels = [...new Set(this.levels)]
                
           }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                this.loading = false;
                if(error.response.status == 404) this.message ='No course found!'
             
            }) 
        this.text1='';
        this.text2='';
        this.LevelNameinsert='0';
        this.IsSelected = false;
        this.Specializationinsert='0';

        },
onChange(serial,event) {

/**
 * set the selected value in local storage to re set the selected value after refresh  
 */

  let selectedsession = localStorage.getItem('selectedsession')
    let selectedData = {name : serial, grade : event.target.value}
    let found
  if(selectedsession == null){
    localStorage.setItem('selectedsession',JSON.stringify([selectedData]))
  }else{
    selectedsession = JSON.parse(selectedsession)
    found =  selectedsession.findIndex(x => {
   
    //return x.serial
   return parseInt( x.name ) === parseInt (serial)
     })
    if (found != -1 ){
      console.log(selectedsession[found].grade)
      selectedsession[found].grade = event.target.value
       localStorage.setItem('selectedsession',JSON.stringify(selectedsession))
    }else{
      selectedsession.push(selectedData)
      localStorage.setItem('selectedsession',JSON.stringify(selectedsession))
    }
  }
  
   studentData.OnChangeGradeSelect(this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert,this.LevelNameinsert,this.text1,this.text2,this.IsSelected,serial,event.target.value).then(Response =>{
            //   this.isLoading = false ;
                    this.selectedgrades = JSON.parse( localStorage.getItem('selectedsession')) == null ? [] : JSON.parse( localStorage.getItem('selectedsession'))

               this.Courses = Response.data
                this.empty =false
 this.Courses =  this.Courses.map(gr=>{
                 return {...gr,Grades :[{GradeSerial : 0 , GradeName : "Choose"},...gr.Grades] }
                 
               })
           }, error => {
              
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
              event.preventDefault()
            },

     onClick(item) {
    // this.deleteClicked = true;
          this.cardLoading = true;

          let selectStatus = item.Selected? 1 : 0;
          
            studentData.SelectDeselectCourse(this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert,this.LevelNameinsert,this.text1,this.text2,this.IsSelected,item.serial,selectStatus).then(Response =>{

            this.Courses = Response.data 
           
            let selectedsession = JSON.parse( localStorage.getItem('selectedsession'))
            if   (selectedsession != null){

              let found =  selectedsession.findIndex(x => { 
                
                 
                return parseInt( x.name ) === parseInt (item.serial)
                  })    
                  if(found != -1){
                    selectedsession.splice(found,1)
                     localStorage.setItem('selectedsession',JSON.stringify(selectedsession))
                     this.selectedgrades = selectedsession
                  }
            }
             this.empty =false               
              this.loading = false;
                       this.Courses =  this.Courses.map(gr=>{
                 return {...gr,Grades :[{GradeSerial : 0 , GradeName : "Choose"},...gr.Grades] }
                 
               })   
                this.cardLoading = false;  
           }, error => {
                               
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       },

   filteredCourses() {
            // this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert, this.LevelNameinsert,this.text1,this.text2,this.IsSelected

     studentData.GetCoursesForSelection(this.currenUser.StudentID,this.currenUser.FacultyID_Enrollment,this.Specializationinsert, this.LevelNameinsert,this.text1,this.text2,this.IsSelected).then(Response =>{
            //   this.isLoading = false ;
               this.Courses = Response.data
                this.empty =false

    if(this.FilterCourses === "All") {
				return this.Courses.Selected === false
			} else if(this.FilterCourses === "Registered") {
			return this.Courses.Registered === true
			}
     
           }, error => {
                              
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 	
		}      
    },
      
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.active2 {
    color: #fff !important;
    
    background-color: #285475  !important;

  }
.active2 button{
  background-color: #28a745 !important;
    margin-bottom: -50px !important;
    width: 50%;

    text-align: center;
    border: 0px;
}

h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #ff8600;
}
.border-right {
    border-right: 1px solid #dee2e6 !important;
}
.iconCart{

width: 60px;
height: 70px;
margin: 0 auto;
position: relative;
padding-top:15px
}
.iconCart .cart{
    position: absolute;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border:#50BD77 dotted 1px;
    top: 0px;
    background: #fff;
    right: 20px;
    text-align: center;
    color: #50BD77;
    font-size: 18px;

}
ul{
    padding-left:0px;
}
li.menu{
    border-bottom: 1px #646464 dashed;
    color: #285475;
    font-size: 17px;
    list-style: none;
    padding: 10px 0px;
}

.card-deck .card {
   
    -webkit-box-flex: 1;
    flex: 1 0 25%;
   
    margin-bottom: 20px;
    padding: 0;
   
}
.subButton{
  margin-bottom: -50px;
    width: 50%;
    background: #285476;
    text-align: center;
    border: 0px;
}
th, td{
  font-size: 0.7rem !important;
}

.popover.b-popover {
  width:300px;
}

.line{
   border-bottom: 1px #646464 dashed;
   padding: 5px 0px;

}
.custom-control-inline {

    margin-right: 0.5rem !important;
}

.beforloader{
  width: 100%;
    background: #3333331c;
    text-align: center;
}
.beforloader> .loader{
  text-align: center;
}
.loader {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
